// anime.js - https://animejs.com/
import anime from 'animejs/lib/anime.es.js';
import {playGirlAndDogTimelines} from './iconography/girl-and-dog';

const initialisePledge = () => {
  const pledgeSteps = document.getElementsByClassName('pledge__step');

  let stepAnimation = anime.timeline({
    duration: 500,
    easing: 'easeInOutQuad',
    loop: false,
    autoplay: false,
  });

  stepAnimation.add({
    targets: '.pledge__step-1',
    opacity: [1, 0],
    complete: () => {
      //
      pledgeSteps[0].classList.add('pledge__step--closed');
      pledgeSteps[1].classList.remove('pledge__step--closed');
    },
  });

  stepAnimation.add({
    targets: '.pledge__step-2',
    opacity: [0, 1],
  });

  // When the user finishes with the form, reveal the social-side and play the
  // girl animation.
  document.getElementById('js:pledge-continue').addEventListener('click', (e) => {
    e.preventDefault();
    stepAnimation.play();
    playGirlAndDogTimelines();
  });
};

exports.initialisePledge = initialisePledge;
